// extracted by mini-css-extract-plugin
export default {"text":"Text-module__text__UCiz4"};